import React from 'react';
import { MediaImg, Title, Description, Link, ExternalLink, LinkIcon } from '../index.styled';
import styled from 'styled-components';
import externalLink from '../../../icons/external_link.svg';
import { useTranslation } from 'react-i18next';

const CONTENT = 'HomePage.ToyotaMedia';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 0 auto;
`

export const MobileCard = ({image, isHome}) => {
  const { t } = useTranslation();
  const title = isHome ? t(`HomePage.ToyotaMedia.title`) : t(`AboutUsPage.SocialBenefit.title`);
  return (
    <Wrapper isHome={isHome}>
      <Title>{title}</Title>
      <MediaImg>
        <img src={image} alt='' role='presentation' />
      </MediaImg>
      <Description>{t(`${CONTENT}.description`)} puto</Description>
      <ExternalLink>
        <Link href='https://pressroom.toyota.com/'>{t(`${CONTENT}.cta`)}</Link>
        <LinkIcon>
          <img src={externalLink} height='12px' width='12px' alt='' role='presentation' />
        </LinkIcon>
      </ExternalLink>
    </Wrapper>
  )
}